import { AnimalGroupBarnMapping } from '../../models/cycle.model';

export enum EditAnimalGroupMode {
  Add = 'add',
  Edit = 'edit',
}

export interface CodelistVaccine {
  country: string;
  name: string;
  plukonId: number;
  registrationNumber: string;
  waitingTime: number;
}

export interface CodelistMedicine {
  country: string;
  name: string;
  plukonId: number;
  registrationNumber: string;
  waitingTime: number;
}

export interface CodelistDiagnosis {
  code: string;
  name: string;
}

export interface CodelistQuantityUnit {
  codeUnit: string;
  unit: string;
  descriptionCode: string;
}

export interface AppliedQuantity {
  measuredValue?: number;
  unitCode?: string;
}

export interface AnimalGroupDataRow {
  id?: number;
  barn?: AnimalGroupBarnMapping;
  barnDisplay?: string;
  country?: string;
}

export interface VaccinationDataRow extends AnimalGroupDataRow {
  date?: string;
  vaccine?: CodelistVaccine;
  vaccineDisplay?: string;
}

export interface MedicationDataRow extends AnimalGroupDataRow {
  startDate?: string;
  endDate?: string;
  medicine?: CodelistMedicine;
  diagnoseCode?: string;
  diagnoseName?: string;
  appliedQuantity?: AppliedQuantity;
  medicineDisplay?: string;
  diagnosisDisplay?: string;
  quantityUnitDisplay?: string;
}

export interface SwitchDayDataRow extends AnimalGroupDataRow {
  date?: string;
  phaseFrom?: number;
  phaseTo?: number;
}
